export * from './env';
export * from './universal-module';
export * from '../common';

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
